import React from 'react';
import util from '../util/util';
import api from '../api/api';
import MobileMenu from './mobileMenu';
import Loader from './loader';
import EventEmitter from './publisher';
import storage from 'storage';
import $ from 'jquery';
import 'pusher-js';

export default class HeaderComp extends React.Component {
    constructor(props){
        super(props);
        this.state = {
			IsLoggedIn: user.isLoggedIn,
			Account: {
				Account: {},
				Emails: {}
			},
			showLoader: false,
			loaderText: '',
			accountPhoto: '',
			cartCount: 0,
			newMessages: 0,
			messageBox: [],
			searchTerm: typeof searchTerm !== "undefined" ? searchTerm : '',
			showMenuOptions: false,
			headerLinksNotLoggedIn_left: [
				{
					name: 'Browse Products',
					link: '/searchResults.cfm'
				},
				{
					name: 'About Us',
					link: '/about.cfm'
				}
			],
			headerLinksLoggedIn_left: [
				{
					name: 'Browse Products',
					link: '/searchResults.cfm'
				}
			],
			headerLinksNotLoggedIn_right: [
				{
					name: 'Login',
					link: '/login.cfm',
					id: 'loginBtn'
				},
				{
					name: 'Sign Up',
					link: '/signup.cfm',
					id: 'signupBtn'
				}
			]
        }

		this.pusher = new Pusher("283da8045fcd72c5a741");

		this.message_channel = this.pusher.subscribe('message');
		this.order_channel = this.pusher.subscribe('Order');
		this.review_channel = this.pusher.subscribe('Review');
    }
	
	componentWillMount() {
		if(user.isLoggedIn) {
			if(storage.get('headerInfo')) {
				this.setState(storage.get('headerInfo'));
			} else {
				this.getHeaderInfo();
			}
			setTimeout(() => {
				if(storage.get('headerInfo')) {
					this.setState(storage.get('headerInfo'));
				} else {
					this.getHeaderInfo();
				}
			}, 300000)
			if(storage.get('account')){
				this.setState({Account: storage.get('account')});
			} else {
				this.getAccountInfo();
			}
		}
		
	}
	
	componentDidMount() {
		EventEmitter.subscribe('updateHeaderText', (data) => {
			this.setState({
				searchTerm: data
			})
		});
		EventEmitter.subscribe('getAccount', (data) => {
			this.getAccountInfo();
		});
		EventEmitter.subscribe('updateHeaderProfileImage', (data) => {
			this.setState({
				accountPhoto: data
			})
		});
		EventEmitter.subscribe('updateHeaderInfo', (data) => {
			this.getHeaderInfo();
		});
		EventEmitter.subscribe('loader', (data) => {
			this.setState({
				showLoader: data.show,
				loaderText: data.text,
			})
		});
		EventEmitter.subscribe('SearchTags', (data) => {
			this.setState({
				searchTerm: data
			}, () => {
				this.refs.searchForm.submit();
			})
		});
		
		this.message_channel.bind('inbox', (data) => {
			if(user.isLoggedIn && data.UserID === user.accountID){
				this.getHeaderInfo();
				util.notification.message("You Received a New Message", "Please go to your Inbox to Read your message");
				EventEmitter.dispatch('updateMessages', {});
			}
		});
		
		this.order_channel.bind('new_order', (data) => {
			if(user.isLoggedIn && data.UserID === user.accountID){
				util.notification.message("New Order Received", "CONGRATULATIONS!! You've got a new Order");
			}
		});
		
		this.review_channel.bind('shop_review', (data) => {
			if(user.isLoggedIn && data.UserID === user.accountID){
				util.notification.message("New Shop Review", "CONGRATULATIONS!! Someone has Reviewed Your Shop");
			}
		});
		
		this.review_channel.bind('item_review', (data) => {
			if(user.isLoggedIn && data.UserID === user.accountID){
				util.notification.message("New Item Review", "CONGRATULATION!! Someone has Reviewed Your Item");
			}
		});
	}
	
	handleSearchChange(e) {
		this.setState({
			searchTerm: this.refs.searchField.value
		})
	}
	
	getAccountInfo() {
		let sendData = {
			method: 'GetAccountJS'
		}
		api.AccountService(sendData).end((err, res) => {
			var result = JSON.parse(res.text);
			
			this.setState({
				Account: result
			}, () => {
				storage.set('account', result);
				storage.expire('account', 1800000);
			});
		});
	}
	
	getHeaderInfo() {
		let sendData = {
			method: 'GetHeaderInfo'
		}
		api.AccountService(sendData).end((err, res) => {
			let result = JSON.parse(res.text);
			let image = result.success == 1 && result.ImagePath != null && result.ImagePath.length > 0 ? result.ImagePath : '';

			if (result.success == 1){
				let headerInfo = {
					accountPhoto: image,
					newMessages:  result.MessageCount,
					cartCount: result.CartCount
				}
				this.setState(headerInfo, () => {
					storage.set('headerInfo', headerInfo);
					storage.expire('account', 300000);
				});
			}
		});
	}
	
	submitSearch(e) {
		if (e.which === 13){
			let eventsList = EventEmitter.getEvents();
			if (typeof eventsList.SearchPage !== 'undefined') {
				e.preventDefault();
				EventEmitter.dispatch('SearchPage', {term: this.refs.searchField.value});
			}
		}
	}
	
	startSelling() {
		return (
			<ul className="col-2"><li><a href="/myAccount/createShop.cfm" className="navMyAccount">Start Selling</a></li></ul>
		)
	}
	
	showMenu() {
		this.setState({
			showMenuOptions: !this.state.showMenuOptions
		});
	}
	
	goToMessages() {
		let eventsList = EventEmitter.getEvents();
		if (typeof eventsList.MyAccountLinks !== 'undefined')
			EventEmitter.dispatch('MyAccountLinks', {name: "messages"});
		else
			window.location.href = '/myAccount/#secmessages';
	}
	
	profileLinks() {
		let Account = util.convertCFJSON(this.state.Account.Account)[0]
		let profileClass = (user.isLoggedIn ? user.gender : '') + ' profilePhoto';
		let profileStyle = user.isLoggedIn && Account && Account.PROFILEIMAGE && Account.PROFILEIMAGE.length > 0 ? {backgroundImage: "url('" + Account.PROFILEIMAGE + "')", display: 'block'} : {display: 'block'};
		let cartTip = this.state.cartCount > 0 ? <div id="cartCount">{this.state.cartCount}</div> : '';
		let messageTip = this.state.newMessages > 0 ? <div id="wishCount">{this.state.newMessages}</div> : '';
		let optionClass = this.state.showMenuOptions ? {padding: 0} : {padding:0, display: 'none'};
		return (
			<ul className="col-4">
				<li id="header-profile-menu">
					<a href="javascript:void(0)" role="button" id="accountMenuBtn" className={profileClass} style={profileStyle}><span className="visuallyhidden">Profile Menu Link</span></a>
					<MenuList />
				</li>
				<li id="cartIcon" className="tooltip-bottom" data-tooltip="Shopping Cart">
					<a href="/shoppingCart.cfm">
						<i className="glyphicon glyphicon-shopping-cart"></i>
						{cartTip}
					</a>
				</li>
				<li className="tooltip-bottom" data-tooltip="Messages">
					<a href="javascript:void(0);" onClick={this.goToMessages.bind(this)}>
						<i className="glyphicon glyphicon-envelope"></i>
						{messageTip}
					</a>
				</li>
			</ul>
		)
	}
	
	renderLinks(theLink, i) {
		let theID = typeof theLink.id !== 'undefined' ? theLink.id : ''
		return(
			<li key={i} id={theID}>
				<a href={theLink.link}>
					{theLink.name}
				</a>
			</li>
		)
	}
	
	assignProps(child, i) {
		if(child.type) {
			return React.cloneElement(child, { Account: this.state.Account });
		} else {
			return child;
		}
		
	}

	openMenu() {
		this.refs.MobileMenu.openMenu();
	}

	render() {
			
		let linkList_left = <ul className="col-2">{!user.isLoggedIn ? this.state.headerLinksNotLoggedIn_left.map(this.renderLinks) : this.state.headerLinksLoggedIn_left.map(this.renderLinks)}</ul>;
		let SearchFieldClass = (user.isLoggedIn ? 'col-xs-5' : 'col-4') + ' headSearch';
		let showMenuList = this.state.showMenuOptions ? <MenuList listData={{align: 'right'}}/> : '';
		let linkList_right = !user.isLoggedIn ? <ul className="col-4">{this.state.headerLinksNotLoggedIn_right.map(this.renderLinks)}</ul> : this.profileLinks();
		let startSellingLink = user.isLoggedIn && user.accountTypeID == 1 ? this.startSelling() : '';
		let componentRender = React.Children.map(this.props.children, this.assignProps.bind(this));
		let mobileMenuLink =  <div className="col-xs-1 glyphicon glyphicon-option-vertical mobileMenuLink mobileShow" onClick={this.openMenu.bind(this)}></div>;
		
		let loader = this.state.showLoader
		return (
			<div className="wrapper">
				<MobileMenu ref="MobileMenu" />
				<header>
					<section className="clearfix">
						<a href="/index.cfm">
							<img src="/images/wubartLogo_sm_2.png" />
						</a>
						{startSellingLink}
						{linkList_left}
						<form action="/searchResults.cfm" ref="searchForm" method="post" id="headerSearchForm" encType="multipart/form-data">
							<div className={SearchFieldClass}>
								<input type="text" name="searchField" ref="searchField" placeholder="Search Items" autoComplete="off" value={this.state.searchTerm} onKeyDown={this.submitSearch.bind(this)} onChange={this.handleSearchChange.bind(this)} />
								<span className="glyphicon glyphicon-search"></span>
							</div>
						</form>
						{linkList_right}
						{mobileMenuLink}
					</section>
					{showMenuList}
				</header>
				{componentRender}
				<Loader loading={this.state.showLoader} loaderText={this.state.loaderText} />
			</div>
		)
	}
}

		
class MenuList extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			header: 'Account Information',
			width: 250,
			align: 'center',
			top: 32,
			right: 10,
			menuItemList: [
				{
					Name: 'My Account',
					link: '/myAccount/',
					clickEvent: () => {}
				},
				{
					Name: 'Logout',
					link: 'javascript:void(0);',
					clickEvent: () => {
						storage.clear();
						window.location = '/logout.cfm';
					}
				}
			]
		}
	}

	createLinks(thelink, i) {
		return (
			<a key={i} href={thelink.link} onClick={thelink.clickEvent}>
				<li className="dataLists clearfix">
					{thelink.Name}
				</li>
			</a>
		)
	}

	render() {
		return (
			<div className="loadTip_container" id="Load1" tabIndex="0" style={{width: this.state.width, top: this.state.top, right: this.state.right}}>
				<div className="loadTip_header">
					Account Information
				</div>
				<div className="loadTip_body">
					<div className="col-12 clearfix accountCategories" style={{padding:0}}>
						<ul className="categoryList" style={{margin:0, border:'none'}}>
							{this.state.menuItemList.map(this.createLinks)}
						</ul>
					</div>
				</div>
				<img src="/images/icons/loadTip_arrow.png" style={{right: 20, left: 'auto', marginLeft: 'auto', marginRight: -16}} />
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./app/reusable/header.js
 **/